const projects = [
	{
		title: "Kalendar",
		logo: "kalendar.png",
		description:
			"An events managment library designed to mirror as many functionalities and features from Google Calendar. To keep things smooth, it uses web workers for heavy calculations.",
		tags: ["vue", "web-workers", "oss", "library"],
		url: "http://kalendar.altinselimi.com",
	},
	{
		title: "Monimo [on-hold]",
		logo: "monimo.png",
		description:
			"Ever had to search for an anime on Netflix only to understand that its not in their library.? Well that happened to me a lot. Monimo is a client application for watching Anime shows.",
		tags: ["electron", "vue", "oss", "sketch"],
		url: "http://github.com/altinselimi/monimo",
	},
	{
		title: "Sticky Chats [deprecated]",
		logo: "stickychats.png",
		description:
			"This is a desktop client for Facebook Messenger. It is built using Electron and VueJS. It is pretty much a replica of Android’s implementation of Messenger chat heads.",
		tags: ["electron", "vue", "scrapping", "oss"],
		url: "http://github.com/altinselimi/stickychats",
	},
	{
		title: "Smooth Twitter",
		logo: "smooth-twitter.png",
		description:
			"To my surprise, navigating in twitter using J and K has no smoothness enabled to it. Just focuses the next tweet. Which is not really a problem. But since we can fix it, why not ?",
		tags: ["chrome-extension", "javascript", "oss"],
		url: "https://chrome.google.com/webstore/detail/smooth-twitter/kacadgbkldklaldffemlifbednldggfj",
	},
];

export default projects;
